import { Record } from 'immutable';
import { schema } from 'normalizr';

export const RelayLoadContract = new Record({
  id: undefined,
  contract_start: undefined,
  contract_end: undefined,
  override_end_date: undefined,
  advertiser: undefined,
  relay_load: undefined,
});

export const relayLoadContractSchema = new schema.Entity('relayLoadContracts');

// for reading in nested models, object with { field: schema }
// relayLoadContractSchema.define({  });
